import { getLocalePrefix, hreflangFor, toPublicLocale, type PublicLocale } from '@/lib/locale-prefix'

export type LegalPage = 'terms' | 'privacy' | 'refunds' | 'support'

const LEGAL_PAGE_BY_PATH: Record<string, LegalPage> = {
  '/terms': 'terms',
  '/privacy': 'privacy',
  '/refunds': 'refunds',
  '/support': 'support',
}

/** Relative URL for a legal page in the requested public locale. */
export function getLegalHref(locale: string, page: LegalPage): string {
  return `${getLocalePrefix(toPublicLocale(locale))}/${page}`
}

/** Relative URL for the public home in the requested locale. */
export function getLegalHomeHref(locale: string): string {
  return getLocalePrefix(toPublicLocale(locale)) || '/'
}

/** Normaliza hrefs legales heredados sin acoplar el routing a cada componente. */
export function resolveLegacyLegalHref(href: string, locale: string): string {
  const page = LEGAL_PAGE_BY_PATH[href]
  return page ? getLegalHref(locale, page) : href
}

/** Shared canonical and hreflang URLs for the legal route family. */
export function buildLegalAlternates(
  baseUrl: string,
  locale: string,
  page: LegalPage
): {
  canonical: string
  languages: Record<PublicLocale | 'x-default', string>
} {
  const urlFor = (publicLocale: PublicLocale) =>
    `${baseUrl}${getLegalHref(publicLocale, page)}`

  return {
    canonical: urlFor(toPublicLocale(locale)),
    languages: hreflangFor(urlFor),
  }
}
